import { deleteDoc, doc } from "firebase/firestore";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Failure from "../../../core/Failure";

async function deleteAdmin(adminId: string): Promise<void> {
  try {
    await deleteDoc(
      doc(firestore, FirestoreCollections.admins, adminId)
    );

    return;
  } catch (e) {
    console.log("error: ", e);
    throw new DeleteAdminFailure();
  }
}

export class DeleteAdminFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default deleteAdmin;
